import ChallengeProgress from './ChallengeProgress';

export default ChallengeProgress;
